/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react' //, {useState}
import RolesCrud from '../../modules/custom/accounts/roles/rolesTable'
const Roles: React.FC = () => {
 
  return (
    <>
      {/*<div className="d-flex flex-column-auto h-60px bg-info-td border-rounded flex-center border rounded">
        <h3 className='text-secondary'> Roles List</h3>
      </div>
  */}
      <div  className='card mb-5 mb-xl-5'>
          <RolesCrud></RolesCrud>
      </div>
    </>
  )
}

export {Roles}
